import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { FormControl } from "@material-ui/core";


import { formatTagsData, getChangedData, getDefaultWidgetName, getFilteredTag, getTagid } from "utils/utils";
import { BarchartWidgetFormStrings, InputErrorStrings, valueStrings, WidgetStrings } from "constants/constantStrings";
import { WIDGET_TITLE_INPUT_MAXIMUM } from "constants/globalConstants";
import { WIDGET_TYPES } from "constants/widgets.type.const";

import CustomModal from "components/CustomModal";
import InputBox from "components/InputBox";
import { TextFieldValidator } from "components/InputBox/TextFieldValidator";
import TagDropdown from "components/TagDropdown";

export default function BarchartWidgetForm(props) {
  const { Header, currentLayout, Function, setIsReportRerendering, isEdit, Attributes, onWidgetAction } = props.data;
  const { tagsAsObj } = useSelector(state => state.tags);
  const Tags = Attributes?.SystemTag.map(tagId => tagsAsObj[tagId]);
  const [tagsList, setTagsList] = useState(props.data.tagsList);

  const getDefaultTags = () => formatTagsData(Tags);
  const widgetDefaultState = {
    Header: Header || getDefaultWidgetName(),
    Attributes: {
      Function: Attributes?.Function || "min",
      Comments: Attributes?.Comments || "",
      SystemTag: { ...getDefaultTags() }
    }
  };
  const [openModal, setOpenModal] = useState(true);
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const [widgetData, setWidgetData] = useState(widgetDefaultState);
  useEffect(() => setWidgetData(widgetDefaultState), [props.data]);

  const levelTypesConfig = [
    { label: BarchartWidgetFormStrings.min, value: "min" },
    { label: BarchartWidgetFormStrings.max, value: "max" },
    { label: BarchartWidgetFormStrings.sum, value: "sum" },
    { label: BarchartWidgetFormStrings.mean, value: "mean" }
  ];

  const getTagsConfig = () => {
    const noOfTags = 3;
    const tagsList = new Array(noOfTags).fill("Tag");
    return tagsList.map((tag, idx) => ({ id: `Tag${idx + 1}`, value: null, required: idx === 0 }));
  };
  const tagDropdownsConfig = getTagsConfig();

  const closeModal = closeType => {
    setOpenModal(false);
    props.onClose(closeType);
  };

  const onTagChange = (idx, value, reason) => {
    const formData = {
      ...widgetData,
      Attributes: { ...widgetData.Attributes, SystemTag: { ...widgetData.Attributes.SystemTag, [`Tag${idx + 1}`]: value } }
    };
    validateForm(formData);
    const filteredTagsList = getFilteredTag(props.data.tagsList, formData?.Attributes?.SystemTag);
    setTagsList(filteredTagsList);
  };

  const onTitleChange = Header => {
    const formData = { ...widgetData, Header };
    validateForm(formData);
  };

  const onLevelChange = event => {
    const Function = event?.target?.value;
    const formData = { ...widgetData, Attributes: { ...widgetData.Attributes, Function } };
    validateForm(formData);
  };

  const validateForm = formData => {
    const { Attributes } = formData;
    const { SystemTag, Function } = Attributes;
    const { Tag1 } = SystemTag;
    const isFormValid = formData.Header && formData.Header.trim().length > 0 && Tag1?.TagId && Function;
    setIsFormInvalid(!isFormValid);
    setWidgetData(formData);
  };

  const getPayload = () => {
    const { Header, Attributes } = widgetData;
    const { Function, Comments, SystemTag } = Attributes;
    let param = {
      Header,
      LayoutID: currentLayout.ID,
      Type: WIDGET_TYPES.BAR_CHART,
      Attributes: {
        Comments: Comments || "",
        Function: Function
      }
    };
    param = getTagid(SystemTag, param);
    return param;
  };
  const getEditTagPaylod = () => {
    let param = getChangedData(widgetData, widgetDefaultState);
    if (param.Attributes?.SystemTag) param = getTagid(widgetData.Attributes?.SystemTag, param);
    return { ...param, Id: props.data.Id, LayoutID: currentLayout.ID };
  };

  const onFormSubmit = async () => {
    setIsFormInvalid(true);
    let payload = {};
    if (isEdit) {
      payload = getEditTagPaylod();
    } else {
      payload = getPayload();
      onWidgetAction("ADD_WIDGET", payload);
      setIsFormInvalid(false);
    }
    closeModal(payload);
  };

  return (
    <>
      {openModal && (
        <CustomModal
          show={openModal}
          title={isEdit ? BarchartWidgetFormStrings.editTitle : BarchartWidgetFormStrings.addTitle}
          confirmBtnText={isEdit ? WidgetStrings.editWidget : WidgetStrings.addWidget}
          description={BarchartWidgetFormStrings.description}
          secondaryDescription={valueStrings.mandatoryField}
          close={closeModal}
          confirmBtnAction={onFormSubmit}
          confirmDisabled={isFormInvalid}
        >
          <div className="widget-form-container">
            <div className="form-group">
              <label className="bodyMainHeadingText" htmlFor="widgetTitle">
                {WidgetStrings.widgetTitle}*
              </label>
              <InputBox
                name="widgetTitle"
                value={widgetData.Header}
                placeholder={WidgetStrings.titlePlaceholder}
                onChange={onTitleChange}
                validator={TextFieldValidator.ALPHANUMERIC_WITH_SPECIAL_CHARS}
                requiredMsg={InputErrorStrings.required}
                maxLength={WIDGET_TITLE_INPUT_MAXIMUM}
              />
            </div>
            {tagDropdownsConfig.map((config, idx) => (
              <div className="form-group" key={idx}>
                <label className="bodyMainHeadingText">
                  {WidgetStrings.selectTag}
                  {config.required && <span>*</span>}
                </label>
                <TagDropdown
                  dropDownID={config.id}
                  tagValue={widgetData.Attributes.SystemTag[`Tag${idx + 1}`]}
                  tagList={tagsList}
                  requiredMsg={config.required && InputErrorStrings.required}
                  onTagChange={(value, reason) => onTagChange(idx, value, reason)}
                />
              </div>
            ))}

            <FormControl>
              <label className="bodyMainHeadingText">{BarchartWidgetFormStrings.levelType}*</label>
              <div className="radio-group">
                {levelTypesConfig.map((level, idx) => (
                  <label className="radiocontainer" key={idx}>
                    {level.label}
                    <input
                      className="radioLabel"
                      type="radio"
                      checked={widgetData.Attributes.Function === level.value}
                      value={level.value}
                      name="levelType"
                      onChange={onLevelChange}
                    />
                    <span className="radioButton" />
                  </label>
                ))}
              </div>
            </FormControl>
          </div>
        </CustomModal>
      )}
    </>
  );
}
